import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'
import de from 'vuetify/es5/locale/de'
import colors from 'vuetify/es5/util/colors'

Vue.use(Vuetify, {
  iconfont: 'fa',
  lang: {
    locales: { de },
    current: 'de'
  },
  theme: {
    primary: colors.green.darken4,
    secondary: colors.green.darken1
  }
})
